import { useCallback, useEffect, useState } from "react";
import { useStaffFormSalon } from "./useStaffFormSalon";

/**
 * The salon's services for the Menu tab. SalonContext only auto-loads them
 * once initial onboarding is complete (and leaves them null if that fetch
 * fails), so the form loads them on demand and reports a failure instead of
 * spinning forever.
 */
export function useMenuServices(enabled: boolean) {
  const { services, refreshServices } = useStaffFormSalon();
  const [loadFailed, setLoadFailed] = useState(false);

  const load = useCallback(async () => {
    setLoadFailed(false);
    const loaded = await refreshServices?.();
    // refreshServices resolves null when it couldn't fetch.
    if (loaded == null) setLoadFailed(true);
  }, [refreshServices]);

  useEffect(() => {
    if (enabled && !services) void load();
  }, [enabled]);

  return { services, loadFailed: !services && loadFailed, retry: load };
}
